import React from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import './SocialLinks.scss';
import { socialLinks } from 'config/profile';

interface SocialLinksProps {
    isExpanded: boolean;
}

interface SocialLinkProps {
    name: string;
    url: string;
    icon: string;
    isExpanded: boolean;
}

export default function SocialLinks({ isExpanded }: SocialLinksProps) {

    const SocialLink = ({ name, url, icon, isExpanded }: SocialLinkProps) => {
        return (
            <Tooltip translateText={true} text={name} position={isExpanded ? 'top' : 'right'}>
                <a href={url} className="social-link" target='_blank' rel="noopener noreferrer">
                    <i className={`fa-brands ${icon}`}></i>
                </a>
            </Tooltip>
        );
    };

    return (
        <div className='container_social'>
            <hr className='divisor'></hr>
            <div className='social-links'>
                {socialLinks.filter((link) => !link.hidden).map((link) => (
                    <SocialLink
                        key={link.name}
                        name={link.name}
                        url={link.url}
                        icon={link.icon}
                        isExpanded={isExpanded}
                    />
                ))}
            </div>
        </div>
    );
}
